import React from "react";
import styles from "./BetTableQueen.module.css";

const fallbackData = [
  { label: "Total 0", back: 0, lay: 0 },
  { label: "Total 1", back: 0, lay: 0 },
  { label: "Total 2", back: 0, lay: 0 },
  { label: "Total 3", back: 0, lay: 0 },
];

// Normalize string for matching
const normalizeString = (str) => {
  if (!str) return "";
  return str
    .replace(/\s*\(\s*/g, '(')
    .replace(/\s*\)\s*/g, ')')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
};

const PlayerOption = ({ label, back, lay, betData, exposures = {} }) => {
  const isBackLocked = back === 0 || back === undefined || betData?.gstatus?.toUpperCase() === "SUSPENDED";
  const isLayLocked = lay === 0 || lay === undefined || betData?.gstatus?.toUpperCase() === "SUSPENDED";

  const selectionName = betData?.nat || label;
  const normalizedSelection = normalizeString(selectionName);

  // Get exposure value
  const getExposure = (betName) => {
    if (!betName) return 0;
    
    const exposureKeys = [
      betName,
      betName?.toLowerCase(),
      betName?.toLowerCase().trim(),
      betName?.trim(),
      normalizeString(betName),
    ];
    
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined && exposures[key] !== null) {
        const expValue = parseFloat(exposures[key]);
        if (!isNaN(expValue)) {
          return expValue;
        }
      }
    }
    
    // Try normalized match against all exposure keys
    const normalizedKey = normalizeString(betName);
    for (const expKey in exposures) {
      const normalizedExpKey = normalizeString(expKey);
      if (normalizedKey === normalizedExpKey) {
        const expValue = parseFloat(exposures[expKey]);
        if (!isNaN(expValue)) {
          return expValue;
        }
      }
    }
    
    return 0;
  };

  // Get exposure
  const totalExposure = getExposure(selectionName);
  const displayExposure = totalExposure !== 0 ? (totalExposure < 0 ? totalExposure.toFixed(0) : `+${totalExposure.toFixed(0)}`) : "0";

  return (
    <div className={styles.playerOption}>
      <span className={styles.label}>{label}</span>
      <div className={styles.betOptions}>
        <div
          className={`${styles.betBox} ${styles.back} ${isBackLocked ? styles.suspendedBox : ""}`}
          style={{ position: 'relative' }}
        >
          {!isBackLocked && (
            <>
              <span className={styles.odds}>{back || 0}</span>
            </>
          )}
          <div className={styles.exposure} style={{
            color: totalExposure !== 0 ? (totalExposure < 0 ? '#ff0000' : '#00ff00') : 'black',
          }}>
            {displayExposure}
          </div>
        </div>

        <div
          className={`${styles.betBox} ${styles.lay} ${isLayLocked ? styles.suspendedBox : ""}`}
          style={{ position: 'relative' }}
        >
          {!isLayLocked && (
            <>
              <span className={styles.odds}>{lay || 0}</span>
            </>
          )}
          <div className={styles.exposure} style={{
            color: totalExposure !== 0 ? (totalExposure < 0 ? '#ff0000' : '#00ff00') : 'black',
          }}>
            {displayExposure}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function BetTableQueen({ data = [], exposures = {} }) {
  const isArray = Array.isArray(data);
  const displayData = (isArray && data.length > 0) ? data : fallbackData;

  return (
    <div className={styles.betTable}>
      {displayData.map((player, index) => (
        <PlayerOption
          key={index}
          label={player.label}
          back={player.back}
          lay={player.lay}
          betData={player}
          exposures={exposures}
        />
      ))}
    </div>
  );
}

